export default [

     {
          path: '/dashboard',
          name: 'Dashboard',
          component: () => import("@/views/Page/Dashboard/Dashboard.vue"),
          meta: {
               title: 'E-GRC | Dashboard',
          },
     }
];